import React, { useState } from 'react';
import { CardFooter } from 'reactstrap';
import { Edit, Send, X, RotateCcw } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ExpertReviewModal from '../Component/ExpertReviewModal';

const CallFormFooter = ({ 
    callFormState, 
    handleOperation, 
    accidentFileId, 
    customerId, 
    callformId,
    initialCustomerContractRate,
    initialIsMiddlemanContractBased,
    initialMiddlemanContractRate,
    initialMiddlemanContractPrice,
    formData 
}) => {
    const navigate = useNavigate();
    const [showExpertReviewModal, setShowExpertReviewModal] = useState(false);

    // Helper function to generate subtle button classes
    const getSubtleButtonClasses = (baseColor) => {
        return `btn border border-${baseColor}-subtle bg-${baseColor}-subtle text-${baseColor}-emphasis d-flex align-items-center ms-2`;
    };

    const handleReturnClick = () => {
        // Eğer "Eksper Onay Bekleniyor" durumundaysa, modal açmadan direkt needExpertReview=true ile işlem yap
        if (callFormState === 'Eksper Onay Bekleniyor') {
            handleOperation('return', { needExpertReview: true });
        } else {
            // "Yönetici Onay Bekleniyor" durumunda modal aç
            setShowExpertReviewModal(true);
        }
    };    const handleExpertReviewConfirm = (needExpertReview) => {
        handleOperation('return', { needExpertReview });
        setShowExpertReviewModal(false);
    };    const handleUpdateCorrections = () => {
        // Check if needExpertReview value exists in formData
        const needExpertReview = formData.needExpertReview;
        
        if (needExpertReview === true) {
            // If expert review is needed, go to "Eksper Onay Bekleniyor"
            handleOperation('expertApproval');
        } else {
            // If expert review is not needed (false) or undefined, go to "Yönetici Onay Bekleniyor"
            handleOperation('managerApproval');
        }
    };

    const toggleExpertReviewModal = () => {
        setShowExpertReviewModal(!showExpertReviewModal);
    };

    return (
        <>
            {['Taslak', 'Yeni Çağrı Formu'].includes(callFormState) && (
                <CardFooter>
                    <div className="d-flex justify-content-end align-items-center w-100">
                        <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('draft')}>
                            <Edit className="me-2" />
                            Taslak Olarak Kaydet
                        </button>
                        <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('save')}>
                            <Send className="me-2" />
                            Çağrı Formu Oluştur
                        </button>
                    </div>
                </CardFooter>
            )}            
            {['Eksper Onay Bekleniyor', 'Yönetici Onay Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={handleReturnClick}>
                                <RotateCcw className="me-2" />
                                Eksik Evrak - İade
                            </button>
                            <button className={getSubtleButtonClasses('danger')} onClick={() => handleOperation('reject')}>
                                <X className="me-2" />
                                Ret
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('approve')}>
                                <Send className="me-2" />
                                Kabul
                            </button>
                        </div>
                    </CardFooter>
                    {/* Modal sadece "Yönetici Onay Bekleniyor" durumunda gösterilsin */}
                    {callFormState === 'Yönetici Onay Bekleniyor' && (
                        <ExpertReviewModal
                            isOpen={showExpertReviewModal}
                            toggle={toggleExpertReviewModal}
                            onConfirm={handleExpertReviewConfirm}
                        />
                    )}
                </>
            )}
            {['Ödeme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('correction')}>
                                <RotateCcw className="me-2" />
                                Düzeltme Bekleyen
                            </button>
                            <button className={getSubtleButtonClasses('danger')} onClick={() => handleOperation('reject')}>
                                <X className="me-2" />
                                Müvekkil Ret
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('complete')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Vekalet Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('received')}>
                                <Send className="me-2" />
                                Tamamlandı
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Evrak Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('received')}>
                                <Send className="me-2" />
                                Tamamlandı
                            </button>
                        </div>
                    </CardFooter>

                </>
            )}
            {['Eksper İşlem Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Eksper Rapor Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}            {['Eksper Raporu Ödeme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('next')}>
                                <Send className="me-2" />
                                Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Sigorta Başvuru Dilekçe Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('warning')} onClick={() => handleOperation('pending')}>
                                <Edit className="me-2" />
                                Kaydet
                            </button>

                            {/* <button 
                                className="btn btn-success d-flex align-items-center ms-2" 
                                onClick={() => handleOperation('submit')}
                            >
                                <Send className="me-2" />
                                Gönder
                            </button> */}

                        </div>
                    </CardFooter>
                </>
            )}            
            {['Düzeltme Bekleniyor'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('success')} onClick={handleUpdateCorrections}>
                                <Send className="me-2" />
                                Düzeltmeleri Gönder
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
            {['Tüm Form'].includes(callFormState) && (
                <>
                    <CardFooter>
                        <div className="d-flex justify-content-end align-items-center w-100">
                            <button className={getSubtleButtonClasses('success')} onClick={() => handleOperation('save')}>
                                <Send className="me-2" />
                                Güncelle
                            </button>
                        </div>
                    </CardFooter>
                </>
            )}
        </>
    );
};

CallFormFooter.propTypes = {
    callFormState: PropTypes.string.isRequired,
    handleOperation: PropTypes.func.isRequired,
    accidentFileId: PropTypes.string,
    customerId: PropTypes.string,
    callformId: PropTypes.string,
    initialCustomerContractRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    initialIsMiddlemanContractBased: PropTypes.bool,
    initialMiddlemanContractRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    initialMiddlemanContractPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    formData: PropTypes.object.isRequired,
};

export default CallFormFooter;
